import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import React, { Component }  from 'react';
import {Tab, Row, Nav, Col, Tabs} from "react-bootstrap";
import {slugify} from "./UpdateProductModal";
import { apiFetch, API, getMarket } from "../../services/api";


export default class AddLandingPageBrandModalForm extends Component {
     constructor(props) {
        super(props);
        this.state = {
            homeAppeareanceImg: "",
            homeSponsoredAppearanceImg: "",
            newDeclination: {
                name : "",
                image: "",
                link: ""
            },
            numberOfNewDeclination: 1,
            numberOfCharMetaTitle: 0,
            numberOfCharMetaDescription:0,
        };
        this.uploadHomeAppearanceImg = this.uploadHomeAppearanceImg.bind(this);
        this.uploadFirstImg = this.uploadFirstImg.bind(this);
        this.uploadHomeSponsoredAppearanceImg = this.uploadHomeSponsoredAppearanceImg.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleClose = () => {
        this.props.selectedLandingPage.language = getMarket()
        return apiFetch(API.back + '/landing-page-brand', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.props.selectedLandingPage)
    })
    .then( () => (this.props.closeModal, window.location.reload(false)))
    .catch( err =>
        console.log(err)
    );
    };

    uploadHomeAppearanceImg(e, slide) {
        const file = e.target.files[0]
        const fileName = e.target.files[0].name
        const reader = new FileReader()

        reader.readAsDataURL(file)

        reader.onload = () => {
            fetch('https://back-api.therunningcollective.fr/upload-file', {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    blob:reader.result,
                    fileName: "landing-page-brands/"+fileName
                })}).then((res) =>
            res.json().then( result =>{
                slide.backgroundImage = result.message
                sleep(1000)
                this.setState({homeAppeareanceImg:  result.message});
            }))}
    }

    uploadHomeSponsoredAppearanceImg(e, slide) {
        const file = e.target.files[0]
        const fileName = e.target.files[0].name
        const reader = new FileReader()

        reader.readAsDataURL(file)

        reader.onload = () => {
            fetch('https://back-api.therunningcollective.fr/upload-file', {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    blob:reader.result,
                    fileName: "landing-page-brands/"+fileName
                })}).then((res) =>
            res.json().then( result =>{
                slide.sponsoredImage = result.message
                sleep(1000)
                this.setState({homeAppeareanceImg:  result.message});
            }))}
    }

    uploadHomeCollectionAppearanceImg(e, slide) {
        const file = e.target.files[0]
        const fileName = e.target.files[0].name
        const reader = new FileReader()

        reader.readAsDataURL(file)

        reader.onload = () => {
            fetch('https://back-api.therunningcollective.fr/upload-file', {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    blob:reader.result,
                    fileName: "landing-page-brands/"+fileName
                })}).then((res) =>
            res.json().then( result =>{
                slide.sportsCollections.image = result.message
                sleep(1000)
                this.setState({homeAppeareanceImg:  result.message});
            }))}
    }

    uploadFirstImg(e, declinaiton) {
        const file = e.target.files[0]
        const fileName = e.target.files[0].name
        const reader = new FileReader()

        reader.readAsDataURL(file)

        reader.onload = () => {
            fetch('https://back-api.therunningcollective.fr/upload-file', {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    blob:reader.result,
                    fileName: "landing-page-brands/"+fileName
                })
            }).then((res) =>
                res.json().then( result =>{
                        sleep(2000)
                        declinaiton.image = result.message
                        this.setState({firstImg:  result.message});
                    }
                )
            )
            .catch( err =>
                console.log(err)
            );
        }
    }

    addNewDeclination(selectedLandingPage){
        if(!selectedLandingPage.sportsCategories){
            selectedLandingPage.sportsCategories = []
        }
        selectedLandingPage.sportsCategories.push(this.state.newDeclination)
        this.setState({numberOfNewDeclination: selectedLandingPage.sportsCategories.length})
    }

    addNewCollectionDeclination(selectedLandingPage){
        if(!selectedLandingPage.sportsCollections.categories){
            selectedLandingPage.sportsCollections.categories = []
        }
        selectedLandingPage.sportsCollections.categories.push(this.state.newDeclination)
        this.setState({numberOfNewCollections: selectedLandingPage.sportsCollections.categories.length})
    }

    removeDeclination(selectedLandingPage, name){
        let list = selectedLandingPage.sportsCategories.filter((declination, index) => declination.name !== name)
        selectedLandingPage.sportsCategories = list
        let nb = this.state.numberOfNewDeclination
        nb--
        this.setState({numberOfNewDeclination: nb})
    }

    removeColectionDeclination(selectedLandingPage, name){
        let list = selectedLandingPage.sportsCollections.categories.filter((declination, index) => declination.name !== name)
        selectedLandingPage.sportsCollections.categories = list
        let nb = this.state.numberOfNewCollections
        nb--
        this.setState({numberOfNewCollections: nb})
    }

    render(){

        return(
            <Modal
                show={this.props.isOpen}
                onHide={this.props.closeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Ajouter une landing page de marque</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        <Row>
                            <Col sm={3}>
                                <Nav variant="pills" className="flex-column">
                                    <Nav.Item>
                                        <Nav.Link eventKey="first">Informations générales</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="second">Disciplines</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="collections">Collections</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="why">Pourquoi la marque ?</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="third">SEO </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                            <Col sm={9}>
                            <Row>
                                <Col>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="first">
                                            <Form.Group >
                                                <Form.Label>Slug : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => this.props.selectedLandingPage.slug = e.target.value} defaultValue={this.props.selectedLandingPage.slug ? this.props.selectedLandingPage.slug : slugify(this.props.selectedLandingPage.title)} placeholder="nike"/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Titre : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => this.props.selectedLandingPage.title = e.target.value} defaultValue={this.props.selectedLandingPage.title} placeholder="Ex : Nike"/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Description : </Form.Label>
                                                <Form.Control  as="textarea" rows={4} onChange={(e) => this.props.selectedLandingPage.description = e.target.value} defaultValue={this.props.selectedLandingPage.description} placeholder="Ex : Cette page..."/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Image de couverture : </Form.Label>
                                                <Form.File
                                                    id="custom-first-img-translate-html"
                                                    label="Ajouter une image"
                                                    data-browse="Ajouter"
                                                    onChange= {(e) => {this.uploadHomeAppearanceImg(e, this.props.selectedLandingPage)}}
                                                    custom
                                                />
                                                {this.props.selectedLandingPage.backgroundImage ?
                                                    <img className="imgToDisplay" alt="Couverture actuelle" src={this.props.selectedLandingPage.backgroundImage}/>
                                                    :
                                                    null
                                                }
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Marque qui ne vend pas de chaussures : </Form.Label>
                                                <Form.Check aria-label="isNotShoes"
                                                            defaultChecked={this.props.selectedLandingPage.isNotShoes}
                                                            onChange={(e) => this.props.selectedLandingPage.isNotShoes = e.target.checked} />
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Lien produits Homme : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => this.props.selectedLandingPage.menCommonLink = e.target.value} defaultValue={this.props.selectedLandingPage.menCommonLink} placeholder="/products/shoes?brands=nike&genders=Men"/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Lien produits Femme : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => this.props.selectedLandingPage.womenCommonLink = e.target.value} defaultValue={this.props.selectedLandingPage.womenCommonLink} placeholder="/products/shoes?brands=nike&genders=Women"/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Image sponsorisée : </Form.Label>
                                                <Form.File
                                                    id="custom-first-img-translate-html"
                                                    label="Ajouter une image"
                                                    data-browse="Ajouter"
                                                    onChange= {(e) => {this.uploadHomeSponsoredAppearanceImg(e, this.props.selectedLandingPage)}}
                                                    custom
                                                />
                                                {this.props.selectedLandingPage.sponsoredImage ?
                                                    <img className="imgToDisplay" alt="Couverture actuelle" src={this.props.selectedLandingPage.sponsoredImage}/>
                                                    :
                                                    null
                                                }
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Filtres meilleurs produits : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => this.props.selectedLandingPage.bestDealsKeyword = e.target.value} defaultValue={this.props.selectedLandingPage.bestDealsKeyword} placeholder="/products/shoes?brands=nike"/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Titre collection à la une : </Form.Label>
                                                <Form.Control  type="text" onChange={(e) => this.props.selectedLandingPage.sportsCollections.name = e.target.value} defaultValue={this.props.selectedLandingPage.sportsCollections.name} placeholder="Ex : Les collection Nike à la une..."/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Image collection à la une : </Form.Label>
                                                <Form.File
                                                    id="custom-first-img-translate-html"
                                                    label="Ajouter une image"
                                                    data-browse="Ajouter"
                                                    onChange= {(e) => {this.uploadHomeCollectionAppearanceImg(e, this.props.selectedLandingPage)}}
                                                    custom
                                                />
                                                {this.props.selectedLandingPage.sportsCollections.image ?
                                                    <img className="imgToDisplay" alt="Couverture actuelle" src={this.props.selectedLandingPage.sportsCollections.image}/>
                                                    :
                                                    null
                                                }
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Articles liés à la marque : </Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    multiple
                                                    onChange={(e) => this.props.selectedLandingPage.posts = [...e.target.selectedOptions].map(o => o.value)}
                                                    defaultValue={this.props.selectedLandingPage.posts}
                                                >
                                                    {(this.props.availablePosts) ? this.props.availablePosts.map(post =>
                                                        <option key={post.slug} value={post.slug}>{post.title.rendered}</option>
                                                    ) : <option>Aucun article disponible</option>}
                                                </Form.Control>
                                            </Form.Group>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="second">
                                            <Tabs id="uncontrolled-tab-example">
                                                {this.props.selectedLandingPage.sportsCategories && this.props.selectedLandingPage.sportsCategories.map((declinaiton, index) =>(
                                                        <Tab key={index} eventKey={index} title={index}>
                                                            <Form.Group >
                                                                <Form.Label>Nom : </Form.Label>
                                                                <Form.Control type="text" onChange={(e) => declinaiton.name = e.target.value} defaultValue={declinaiton.name} placeholder="Athlétisme"/>
                                                            </Form.Group>
                                                            <Form.Group >
                                                                <Form.Label>Lien : </Form.Label>
                                                                <Form.Control type="text" onChange={(e) => declinaiton.link = e.target.value} defaultValue={declinaiton.link} placeholder="/products/shoes?brands=nike&genders=Men"/>
                                                            </Form.Group>
                                                            <Form.Group >
                                                                <Form.Label>Image de couverture : </Form.Label>
                                                                <Form.File
                                                                    id="custom-first-img-translate-html"
                                                                    label="Ajouter un image"
                                                                    data-browse="Ajouter"
                                                                    onChange= {(e) => {this.uploadFirstImg(e, declinaiton)}}
                                                                    custom
                                                                />
                                                                {declinaiton.image ?
                                                                        <img className="imgToDisplay" alt="Couverture actuelle" src={declinaiton.image}/>
                                                                    :
                                                                    null
                                                                }
                                                            </Form.Group>
                                                        </Tab>
                                                ))}
                                                <Tab eventKey={this.props.selectedLandingPage.sportsCategories && this.props.selectedLandingPage.sportsCategories.length} title={<Button variant= "secondary" onClick={() => this.addNewDeclination(this.props.selectedLandingPage)}>+</Button>}>
                                                </Tab>
                                            </Tabs>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="collections">
                                            <Tabs id="uncontrolled-tab-example">
                                                {this.props.selectedLandingPage.sportsCollections.categories && this.props.selectedLandingPage.sportsCollections.categories.map((declinaiton, index) =>(
                                                        <Tab key={index} eventKey={index} title={index}>
                                                            <Form.Group >
                                                                <Form.Label>Nom : </Form.Label>
                                                                <Form.Control type="text" onChange={(e) => declinaiton.name = e.target.value} defaultValue={declinaiton.name} placeholder="Invincible"/>
                                                            </Form.Group>
                                                            <Form.Group >
                                                                <Form.Label>Lien : </Form.Label>
                                                                <Form.Control type="text" onChange={(e) => declinaiton.link = e.target.value} defaultValue={declinaiton.link} placeholder="/products/shoes?keywords=invincible"/>
                                                            </Form.Group>
                                                            <Form.Group >
                                                                <Form.Label>Image de couverture : </Form.Label>
                                                                <Form.File
                                                                    id="custom-first-img-translate-html"
                                                                    label="Ajouter un image"
                                                                    data-browse="Ajouter"
                                                                    onChange= {(e) => {this.uploadFirstImg(e, declinaiton)}}
                                                                    custom
                                                                />
                                                                {declinaiton.image ?
                                                                        <img className="imgToDisplay" alt="Couverture actuelle" src={declinaiton.image}/>
                                                                    :
                                                                    null
                                                                }
                                                            </Form.Group>
                                                        </Tab>
                                                ))}
                                                <Tab eventKey={this.props.selectedLandingPage.sportsCollections.categories && this.props.selectedLandingPage.sportsCollections.categories.length} title={<Button variant= "secondary" onClick={() => this.addNewCollectionDeclination(this.props.selectedLandingPage)}>+</Button>}>
                                                </Tab>
                                            </Tabs>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="why">
                                            <Tabs id="uncontrolled-tab-example">
                                                <Tab key={"why"} eventKey={"why"} title={"why0"}>
                                                    <Form.Group >
                                                        <Form.Label>Titre : </Form.Label>
                                                        <Form.Control type="text" onChange={(e) => this.props.selectedLandingPage.why.name = e.target.value} defaultValue={this.props.selectedLandingPage.why.name} placeholder="Ex : Pourquoi choisir Nike ?"/>
                                                    </Form.Group>
                                                    <Form.Group >
                                                        <Form.Label>Description : </Form.Label>
                                                        <Form.Control  as="textarea" rows={4} onChange={(e) => this.props.selectedLandingPage.why.link = e.target.value} defaultValue={this.props.selectedLandingPage.why.link} placeholder="Ex : Nike, bien plus qu'une marque de sport..."/>
                                                    </Form.Group>
                                                </Tab>
                                            </Tabs>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="third">
                                            <Form.Group >
                                                <Form.Label>Balise Titre : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => {this.props.selectedLandingPage.metaTitle = e.target.value; this.setState({numberOfCharMetaTitle: e.target.value})}} defaultValue={this.props.selectedLandingPage.metaTitle} placeholder="Ex : Nike"/>
                                                <Form.Text className="text-muted">
                                                    {this.state.numberOfCharMetaTitle ? this.state.numberOfCharMetaTitle.length : this.props.selectedLandingPage.metaTitle.length} des 70 caractères utilisés (recommandé)
                                                </Form.Text>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Meta Description : </Form.Label>
                                                <Form.Control as="textarea" rows={4} onChange={(e) => {this.props.selectedLandingPage.metaDescription = e.target.value; this.setState({numberOfCharMetaDescription: e.target.value})}} defaultValue={this.props.selectedLandingPage.metaDescription} placeholder="Cette marque est ..."/>
                                                <Form.Text className="text-muted">
                                                    {this.state.numberOfCharMetaDescription ? this.state.numberOfCharMetaDescription.length : this.props.selectedLandingPage.metaDescription.length} des 160 caractères utilisés (recommandé)
                                                </Form.Text>
                                            </Form.Group>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    </Tab.Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" type="cancel" onClick={this.props.closeModal}>
                        Annuler
                    </Button>
                    <Button variant="primary" type="submit" onClick={this.handleClose}>
                        Valider
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export function sleep(time){
    return new Promise((resolve)=>setTimeout(resolve,time)
    )
}